export default __webpack_public_path__ + "static/media/green_check_circle.781133b8.svg";